import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tgeBackground from "@/assets/earning-coins-bg.png";
import { BoxButton } from "@/components/Buttons/Button";
import { Box } from "@/components/Layout/Box";
import { Media, breakpoints } from "@/styles";
import { useWidthBreakpoint } from "@/hooks";

const startTime = 1705960800; // Jan 22, 2024 2PM PST

const buildChunks = (timeRemaining: number) => {
    const formatTime = (time: number) => {
      if (time < 10) {
        return "0" + time.toString();
      } else {
        return time.toString();
      }
    };

    const chunks = [
        formatTime(Math.floor(timeRemaining / 86400)), // Days
        formatTime(Math.floor((timeRemaining % 86400) / 3600)), //Hours
        formatTime(Math.floor((timeRemaining % 3600) / 60)), //Minute
        formatTime(timeRemaining % 60) //Seconds
    ];

    return chunks
  };

const startChunks = buildChunks(startTime - Math.floor(Date.now() / 1000))

export const TGECountdown = ({ isLoading, hideSeconds }: any) => {

  const [timeChunks, setTimeChunks] = useState(startChunks);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!isLoading) {
        const currentTime = Math.floor(Date.now() / 1000);
        const diff = startTime - currentTime; //TODO: fix
        if (diff < 1) {
          window.location.reload();
        }

        setTimeChunks(buildChunks(diff));
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [isLoading]);

  return (
    <UpcomingBox>
      <UpcomingBoxTitle>$SHELL is almost here!</UpcomingBoxTitle>
      <UpcomingBoxDescription>Launches in:</UpcomingBoxDescription>
      <UpcomingBoxTimeContainer>
        {timeChunks.map((chunk, index) => {
          if(index == timeChunks.length - 1 && hideSeconds) return <></>
          return (
            <>
              {index != 0 && (
                <UpcomingBoxTimeColon>:</UpcomingBoxTimeColon>
              )}
              <UpcomingBoxTimeBoxes>
                <UpcomingBoxTimeBox>
                  <span>{chunk[0]}</span>
                </UpcomingBoxTimeBox>
                <UpcomingBoxTimeBox>
                  <span>{chunk[1]}</span>
                </UpcomingBoxTimeBox>
              </UpcomingBoxTimeBoxes>
            </>
          );
        })}
      </UpcomingBoxTimeContainer>
    </UpcomingBox>
  );
};

export const UpcomingBox = styled(Box)`
  padding: 16px 24px 12px;
  background-image: url(${tgeBackground});
  background-position: right 3px;
  background-repeat: no-repeat;
  background-blend-mode: luminosity;
  margin-bottom: 8px;

  border-radius: 16px;
  border: 1px solid var(--dark-2, #171b33);

  ${Media.tablet} {
    padding: 16px;
    background-image: none;
  }
`;

const UpcomingBoxTitle = styled.div`
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.9px;
`;
const UpcomingBoxDescription = styled.div`
  color: var(--grey-3, #7d7d97);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 136%; /* 21.76px */
  margin-top: 8px;
`;
const UpcomingBoxTimeContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
`;
const UpcomingBoxTimeBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid var(--dark-3, #1e2239);
  background: var(--dark-4, #151530);
  span {
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.9px;
    background: var(
      --gradient-2,
      linear-gradient(135deg, #37dcf2 0%, #07c0fb 100%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    -webkit-animation-name: glow;
    -moz-animation-name: glow;
    animation-name: glow;
    -webkit-animation-duration: 2s;
    -moz-animation-duration: 2s;
    animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;

    @keyframes glow {
      0% {
        text-shadow: 0 0 0px #00bdff;
      }

      50% {
        text-shadow: 0 0 4px #00bdff;
      }

      100% {
        text-shadow: 0 0 0px #00bdff;
      }
    }

    ${Media.mobile} {
      font-size: 12px;
    }
  }
`;

const UpcomingBoxTimeBoxes = styled.div`
  display: flex;
  gap: 4px;
`;

const UpcomingBoxTimeColon = styled.div`
  font-size: 30px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.9px;
  color: var(--white, #fff);
`;
